import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  registered: {
    id: 'Registered',
    defaultMessage: 'Registered',
  },
  checked: {
    id: 'Checked-In',
    defaultMessage: 'Checked-In',
  },
  cancelled: {
    id: 'Cancelled',
    defaultMessage: 'Cancelled',
  },
  refunded: {
    id: 'Refunded',
    defaultMessage: 'Refunded',
  },
});
